import { union } from "superstruct";

import { RewardsDiscountCodeRewardSchema } from "../RewardsRewardSchemas/RewardsDiscountRewardSchema";
import { RewardsFreeProductDiscountCodeRewardSchema } from "../RewardsRewardSchemas/RewardsFreeProductRewardSchema";
import { RewardsGiftCardBalanceRewardSchema } from "../RewardsRewardSchemas/RewardsGiftCardRewardSchema";

export const RewardsCustomerRewardSchema = union([
    RewardsDiscountCodeRewardSchema,
    RewardsFreeProductDiscountCodeRewardSchema,
    RewardsGiftCardBalanceRewardSchema,
]);
